import React from "react";

function History() {
	return (
		<div style={{ marginBottom: '100px' }}>
			<div className="row banner" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
			<div class="container">
				<div
					className="container animated-border"
					style={{
						marginTop: '50px',
						marginBottom: '50px',
						background: 'white',
						borderRadius: '15px'
					}}
				>
					<div className="row">
						<div
							className="col-12 col-md-5"
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								padding: '25px'
							}}
						>
							<img
								src="./images/child.jpeg"
								alt="Maruthi Temple"
								style={{ width: '100%' }}
							/>
						</div>

						<div
							className="col-12 col-md-7"
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center'
							}}

						>
							<h3 className="hheading" style={{ paddingLeft: '50px', paddingTop: '50px' }}>കുട്ടി​കളെ ഹനുമാൻ‍ സ്വാമിയുടെ നടയിൽ അടിമയിരുത്തുന്ന ചടങ്ങ്</h3>
							<p className="about">
								ശ്രീകൃഷ്ണമാരുതി ക്ഷേത്രത്തിലെ പ്രധാന ചടങ്ങാണ് കുട്ടികളെ അടിമയിരുത്തൽ. അടിമയിരുത്തുന്നത് വിദ്യാവർദ്ധനവിനും ബുദ്ധിഗുണത്തിനും ബാലാരിഷ്ടത മാറുന്നതിനും ഉത്തമമാണ്. <br />
								ഹനുമാൻ സ്വാമിയുടെ നടയിൽ കുട്ടികളെ അടിമയിരുത്തുന്നതിലൂടെ കുട്ടിയും സ്വാമിയും തമ്മിൽ ഗുരുശിഷ്യ ബന്ധമുണ്ടാകുന്നു. കുട്ടിയുടെ ബാല്യം, കൗമാരം, യൗവനം, വാർദ്ധക്യം തുടങ്ങി ജീവിതാവസാനം വരെ ഹനുമാൻസ്വാമി കൂടെയുണ്ടാകണമെന്ന പ്രാർത്ഥനയോടെയാണ് കുട്ടികളെ അടിമയിരുത്തുന്നത്. തൻ്റെ രക്ഷയ്ക്ക് ഹനുമാൻ സ്വാമി എപ്പോഴും കൂടെയുണ്ടെന്ന വിശ്വാസം കുട്ടികളുടെ മനസ്സിൽ ഉണ്ടാക്കാൻ ഇത് സഹായിക്കും.വിജയത്തിലേക്കുള്ള യാത്രയിൽ കുട്ടികൾക്ക് മനോബലം വർദ്ധിക്കുവാൻ‍ സഹായിക്കും.  മീനമാസത്തിലെ രോഹിണി നക്ഷത്രത്തിലാണ് ഈ ചടങ്ങ്. ഒരു വയസിനു ശേഷം 10 വയസ് വരെ അടിമയിരുത്താം. <br />
								ഏഴ് ദിവസം വ്രതം ആചരിക്കണം. ഒരു കിഴിപ്പണവും ഫലമൂലാദികളും സമർപ്പിച്ചാണ് ചടങ്ങ് നടത്തുന്നത്.

							</p>
						</div>
					</div>
				</div>




				{/* <div class="row" >
          <div className="col-md-4 imagebox" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgrooundPosition: 'center', backgroundSize: 'cover' }}>

          </div>
          <div className="col-md-8 historybox " >
            <h3 className="hheading">41 ദിവസത്തെ വ്രതവും മണിപൂജയും </h3>
            <p className="hcontent">
              അഭിഷ്ട കാര്യസിദ്ധിക്കായി മണി പു ജിച്ച് കെട്ടുന്നത് ഈ ക്ഷേത്രത്തിലെ സവിശേഷതയാണ്. മണി കെട്ടിയ ശേഷം 41 ദിവസം വൃതമാചരിക്കുകയും ഹനുമദ് മന്ത്രം ജപിക്കുകയും വേണം. 41-ാം ദിവസം ഹനുമാൻ സ്വാമിക്ക് നെയ്യ് സമർപ്പിച്ച് വ്രതം അവസാനിപ്പിക്കാം.
            </p>
          </div>
        </div> */}
				<div class="row" >
					
					<div className="col-md-12 historybox" >
						<img src="./images/pic-2a.jpeg" alt="" style={{width:'100%'}} />
						<h3 className="hheading"></h3>
						<p className="about">
							ചേര സാമ്രാജ്യകാലത്ത് വഞ്ചി എന്നാണ് ഇന്നത്തെ തിരുവഞ്ചിക്കുളം അറിയപ്പെട്ടിരുന്നത്. ചേര സാമ്രാജ്യത്തിനു നേരെ ​ചോളന്മാരുടെ ആക്രമണമുണ്ടായ കാലത്ത് ചേര രാജാവിനെ സഹായിച്ച ഈഴവന്മാരിൽ കാരയിൽ തറവാട്ടിലെ യോദ്ധാക്കൾക്ക് മുഖ്യ പങ്കുണ്ടായിരുന്നു. കാരയിൽ തറവാട്ടിലെ പുരോഹിതനായിരുന്ന കുഞ്ഞിവേലു ആചാര്യൻ‍ കുലദേവത പൂജകൾക്കു ശേഷം ഉപരി പഠനത്തിനായി കൊല്ലം ദേശത്തേക്ക് പോവുകയും താന്ത്രിക, മാന്ത്രിക വേദാന്ത പഠനങ്ങൾക്കായി യോഗിവര്യനായ കേശവൻ‍ എന്ന മഹായോഗിയുടെ ശിഷ്യത്വം സ്വീകരിക്കുകയും ചെയ്തു. <br />
							പഠനാനന്തരം തന്റെ പ്രത്യക്ഷ ഉപാസന മൂർത്തിയായ ​ശൈവ രൂപത്തിലുള്ള ഹനുമാൻ‍ സ്വാമിയെ പ്രിയ ശിഷ്യനായ കുഞ്ഞിവേലു ആചാര്യനു നൽകി അനുഗ്രഹിക്കുകയും ഗുരു സമാധി ആവുകയും ചെയ്തു. കുഞ്ഞിവേലു ആചാര്യൻ‍ ഹനുമാൻ‍ സ്വാമിയെ ത​ന്റെ ഗ്രാമത്തിലേക്ക് കൊണ്ട് വന്ന് പ്രതിഷ്ഠിക്കുകയും ചെയ്തു. രൗദ്രമൂർത്തിയായ സ്വാമിയുടെ രൗദ്രത കുറയ്ക്കുന്നതിനായി ബാലരൂപത്തിലുള്ള ശ്രീകൃഷ്ണ ഭഗവാനെ പ്രതിഷ്ഠിക്കുകയുണ്ടായി. ​തന്റെ ഗുരുവായ കേശവ ഗുരുവിനെ ഗുരുമുത്തപ്പനായും, കുലദേവതയായ തണ്ണികുളങ്ങര ഭഗവതിയെ​യും ഗണപതിയെയും ഉപതദേവതകളായി പ്രതിഷ്ഠിച്ച ക്ഷേത്രം പിന്നീട് ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്രം എന്ന പേരിൽ പ്രസിദ്ധമായി

						</p>
					</div>
				</div>

				<div class="row" >
					<div className="col-md-4 imagebox" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgrooundPosition: 'center', backgroundSize: 'cover' }}>

					</div>
					<div className="col-md-8 historybox" >
						<h3 className="hheading">ഭാരതത്തിലാദ്യമായി ഹനുമാൻ സ്വാമിയുടെ കളമെഴുത്തു പാട്ടിൻ്റെ തുടക്കം </h3>
						<p className="about">
							ഹനുമാൻ സ്വാമിയുടെ രൂപക്കളമെഴുത്തു പാട്ടിന് മൂന്ന് തലമുറകൾക്ക് മുമ്പ് ഭാരതത്തിൽ ആദ്യമായി മാരുതിപുരം ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്രത്തിലാണ് തുടക്കം കുറിച്ചത്. ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്ര നടയിൽ ഹനുമാൻസ്വാമിക്ക് കളമെഴുത്ത് പാട്ട് രചിച്ചതും അവതരിപ്പിച്ചതും കോരുവേലൻ എന്ന മഹാനായ വ്യക്തിയാണ്. ഇന്നും ശ്രീകൃഷ്ണ മാരുതിപുരം ക്ഷേത്രത്തിലെ രോഹിണി മഹോത്സവത്തിലെ പ്രധാന ചടങ്ങ് ഹനുമാൻ സ്വാമിയുടെ രൂപക്കള മെഴുത്തും പാട്ടുമാണ്.

						</p>
					</div>
				</div>
				<div class="row" >
					<div className="col-md-4 imagebox" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgrooundPosition: 'center', backgroundSize: 'cover' }}>

					</div>
					<div className="col-md-8 historybox" >
						<h3 className="hheading">ഒമ്പതാം വയസിൽ മേൽശാന്തി</h3>
						<p className="about">
							ശ്രീകൃഷ്ണമാരുതി ക്ഷേത്രത്തിലെ ഹനുമാൻ സ്വാമിയെ പൂജിച്ച് വരുന്ന മൂന്നാം തലമുറക്കാരനാണ് വിഷ്ണുശാന്തി. പിതാമഹൻ കുഞ്ഞിവേലു ആചാര്യൻ. അ ദ്ദേഹത്തിൻ്റെ മകൻ വൈദ്യരത്നം കുട്ടൻ ശാന്തിയുടേയും സജിതയുടേയും മകനാണ്. വളരെ ചെറുപ്പത്തിൽ തന്നെ അച്ഛൻ്റെ ശിക്ഷണത്തിൽ ഹനുമാൻ സ്വാമിയുടെ പൂജ ചെയ്തു തുടങ്ങിയിരുന്നു. തൻ്റെ 9-ാം വയസ്സിൽ അച്ഛൻ്റെ മരണത്തെ തുടർന്ന് ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്രത്തിലെ മേൽശാന്തിയായി ചുമതലയേറ്റു. ശ്രീ നാരായണ ഗുരു ശിഷ്യ പരമ്പരയിലെ പ്രമുഖനായ കോരു ആശാൻ്റെ ശിഷ്യനായ തറയിൽ സുബ്രഹ്മണ്യ തന്ത്രിയിൽ നിന്ന് പൂജാപഠനവും ബ്രഹ്മ ശ്രീ തിലകൻ തന്ത്രികളിൽ നിന്ന് ഉപരിപഠനവും നേടി. എസ്.എൻ.എം. മാല്യങ്കര കോളേജിൽ ബി.എ മലയാളം പഠനവും 10 വർഷത്തെ ജ്യോതിഷ പഠനജ്ഞാനവും നേടി. ചെറുപ്പം മുതലേ സാമുഹിക പ്രതിബദ്ധത നാമ്പിട്ടിരുന്ന ശ്രീവിഷ്ണുശാന്തി സ്വന്തം വിവാഹത്തിന് ആഡംബരങ്ങളൊക്കെ ഒഴിവാക്കി അതേ വേദിയിൽ നിർദ്ധനയായ മറ്റൊരു പെൺകുട്ടിക്ക് മാംഗല്യ സൗഭാഗ്യമൊരുക്കി സമുഹത്തിന് മാത്യകയായി. അമ്മ സജിത. <br />
							ഭാര്യ: അശ്വതി. മക്കൾ: ബജ്‌രംഗ്, രുദ്രാക്ഷ്. കൃഷിയിൽ സജീവമായ വിഷ്ണുശാന്തിയ്ക്ക് എടവിലങ്ങ് പഞ്ചായത്തിലെ യുവകർഷകനുള്ള പുരസ്ക്കാരവും (2024) ലഭിച്ചു. ശ്രീനാരായണ ഗുരു ദേവ ധർമ്മങ്ങളിൽ അധിഷ്ഠിതമായ പൂജാദികർമ്മങ്ങളും ആത്മീയ ആശയങ്ങളും ഭക്തജന ങ്ങളിലേക്ക് പകർന്നു നൽകുകയും ഇന്ന് കൊടുങ്ങല്ലൂരിലെ പ്രധാന ശാന്തിമാരിൽ ഒരാളായി മാറുകയും ചെയ്തു. ആദ്ധ്യാത്മിക, സാമൂഹ്യസേവന, കാർഷി കമേഖലയിലെല്ലാം വ്യക്തിമുദ്ര പതിപ്പിച്ചാണ് യഥാർത്ഥ ഭക്തിയോടെ, സമർപ്പിതമനസോടെയുളള ഉപാസകനായി വിഷ്ണുശാന്തി ഭഗവാനിൽ സ്വയം സമർപ്പിക്കുന്നത്.

						</p>
					</div>
				</div>


			</div>

		</div>
	);
}

export default History;
